import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import techDocsMermaidAddonModule from 'backstage-plugin-techdocs-addon-mermaid/alpha';
import { navModule } from './modules/nav';
import { githubSignInModule } from './sign-in-page';
import { changelogModule } from './modules/changelog';

export default createApp({
  features: [
    catalogPlugin,
    techDocsMermaidAddonModule,
    navModule,
    githubSignInModule,
    changelogModule,
  ],
});
